import { Card, CardContent, Typography } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';

export const PriorityInsights = ({ results }) => {
  if (!results.priority_insights?.length > 0) return null;
  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <InsightsIcon color="primary" /> Priority Insights
        </Typography>
        <List dense>
          {results.priority_insights.map((insight, i) => (
            <ListItem key={i} disableGutters>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <InsightsIcon fontSize="small" color="disabled" />
              </ListItemIcon>
              <ListItemText primary={insight} primaryTypographyProps={{ variant: 'body2' }} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
